export default "__VITE_ASSET__CBENvaDz__"